import React from 'react';

import { connect } from 'react-redux';

import appSettings from 'wanderu-config';
import { languageSelector } from 'wanderu-i18n';

import Footer from '../../components/Footer/Footer';

interface FooterContainerProps {
    language: string
}

interface I18nState {
    currency: string;
    locale: string;
    supportedCurrencies: [];
    supportedLocales: [];
}

interface StateProps {
    i18n: I18nState;
}

function FooterContainer(props: FooterContainerProps) {
    const {
        language,
        ...otherProps
    } = props;

    return (
        <Footer
            buildId={appSettings.env.build.gitHash}
            language={language}
            region={appSettings.config.aws.region}
            version={appSettings.env.build.version}
            {...otherProps}
        />
    );
}

function mapStateToProps(state: StateProps) {
    return {
        language: languageSelector(state),
    };
}

export { FooterContainer };
export default connect(mapStateToProps)(FooterContainer);
